import React from "react";

const AboutMe = () => {
  return (
    <div className="my-6" id="aboutMe">
      <h2 className="text-2xl font-bold">About Me</h2>
      <div>
        <div className="hero">
          <div className="hero-content flex-col lg:flex-row">
            <div>
              <p className="py-6 text-left">
                Aspiring front-end developer. MERN stack course completed from
                programming hero. Good at spa Frontend development (React).
                Comfortable with Node js and have some work done with mongodb.
              </p>
              <p className=" text-left ">
                <span className="font-bold">Certification:</span>
                <span className="ml-3">MERN Stack</span> -
                <a
                  className=" underline"
                  href="https://web.programming-hero.com/"
                  target="_blank"
                >
                  Programming Hero
                </a>
                <br />
                <span className="font-bold mr-4">Languages:</span>
                <span className="">English-Fluent</span>
                <span className="mx-4">Hindi-Proficient</span>
                <span className="">Bengali-Native</span>
                <br />
                <span className="font-bold mr-4">Love to:</span>
                <span>
                  Play Chess (1700+ ratings in{" "}
                  <a
                    className="underline"
                    href="https://lichess.org/"
                    target="_blank"
                  >
                    lichess
                  </a>
                  )
                </span>
                <br />
                <br /> <span className="font-bold">Professionalism:</span>
                <br /> Senior Associate - Quantanite
                <br />
                Full-time Feb 2018 - Nov 2022
                <br />
                <span>
                  Professionally worked with more than 12 individual clients and
                  three different teams. Have almost 1.5 years of experience in
                  data processing and more than three years of experience in
                  doing lead generation.
                </span>
                <br />
                <br /> <span className="font-bold">Education:</span>
                <br /> B.Sc in CSE -{" "}
                <a
                  className="underline"
                  href="https://wub.edu.bd/"
                  target="_blank"
                >
                  World University of Bangladesh
                </a>
                <br />
                April 2014 - Dec 2017
                <br />
                Reg: wub-03/14/31/1044
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
